import Loading from '@justgiving/loading';
import Alert from '@justgiving/alert';
import React, { Component } from 'react';

import { Field } from 'redux-form';
import FormError from 'components/Alert/FormError';
import { PropTypes } from 'prop-types';
import { Trans } from 'react-i18next';
import { createErrorKey } from 'utils';
import { renderField } from 'utils/FormUtils';

class VerifyPhoneFormComponent extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    trackPageView: PropTypes.func.isRequired,
    trackLinkClick: PropTypes.func.isRequired,
    submitHandler: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    status: PropTypes.shape({
      fetchError: PropTypes.bool.isRequired,
      postError: PropTypes.bool.isRequired,
      errorMessage: PropTypes.string,
    }).isRequired,
    resendCode: PropTypes.func.isRequired,
    verifyPhone: PropTypes.shape({
      verified: PropTypes.bool,
      phoneNumber: PropTypes.string,
      resendCode: PropTypes.bool,
    }).isRequired,
    history: PropTypes.shape({
      push: PropTypes.func,
    }),
  };

  static defaultProps = {
    submitting: false,
    submitSucceeded: false,
    error: false,
    initialValues: {},
  };

  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.resendCode = this.resendCode.bind(this);
  }

  componentDidMount() {
    const { trackPageView } = this.props;
    trackPageView(
      'phone',
      'personal details > phone > verify number',
      'verify number',
    );
  }

  componentWillUnmount() {
    this.props.reset();
  }

  onSubmit(values) {
    const { trackLinkClick, submitHandler, history } = this.props;
    trackLinkClick(
      'button',
      'personal details > phone > verify number',
      'continue',
    );
    return submitHandler(values, history.push);
  }

  resendCode(e) {
    e.preventDefault();
    const { trackLinkClick, resendCode, verifyPhone } = this.props;
    trackLinkClick(
      'button',
      'personal details > phone > verify number',
      'resend code',
    );
    const phoneNumber = verifyPhone.phoneNumber;
    resendCode(phoneNumber);
  }

  render() {
    const { status, handleSubmit, submitting, verifyPhone, error } = this.props;

    const errorKey = createErrorKey(status.errorMessage);

    return (
      <form
        method="POST"
        className="jg-space-mtmd"
        onSubmit={handleSubmit(this.onSubmit)}
      >
        {(status.errorMessage || error) && <FormError apiError={errorKey} />}
        {verifyPhone.resendCode && (
          <Alert type="success" className="qa-message__success jg-space-mbmd">
            <Trans i18nKey="phoneForm.codeResent">
              A SMS code has been resent.
            </Trans>
          </Alert>
        )}
        <div className="jg-form-group">
          <label htmlFor="VerificationCode" className="jg-form-label">
            <Trans i18nKey="phoneForm.smsCode">SMS code</Trans>
            <Field
              name="VerificationCode"
              component={renderField}
              type="text"
              label="SMS code"
              disabled={Boolean(status.fetchError)}
            />
            <Field
              name="PhoneNumber"
              component={renderField}
              type="hidden"
              label="Phone Number"
            />
          </label>
        </div>
        <div>
          {!verifyPhone.verified && (
            <button
              type="button"
              className="jg-btn--link"
              onClick={this.resendCode}
            >
              <Trans i18nKey="phoneForm.resendCode">Resend code</Trans>
            </button>
          )}
          <br />
          <br />
        </div>
        <div className="jg-form-group">
          {submitting ? (
            <button type="submit" className="jg-btn jg-btn--brand" disabled>
              <Loading size="small" colour="white" />
            </button>
          ) : (
            <button
              type="submit"
              className="jg-btn jg-btn--brand qa-button__submit"
              disabled={status.fetchError}
            >
              <Trans i18nKey="common.continue">Continue</Trans>
            </button>
          )}
        </div>
      </form>
    );
  }
}

export default VerifyPhoneFormComponent;
